import { ActivatedRouteSnapshot } from '@angular/router'
import { getEnumValues, HOME_SLUG, Language } from '@pai/commons'

import { SiteDto } from 'app/core/cms/type-unions'
import { RoutePath } from 'app/static/route-path.enum'

const SITE_TYPE_PATH: { [K in SiteDto['__typename']]: [] | [string] } = {
  Page: [],
  Project: [RoutePath.PROJECTS],
  Publication: [RoutePath.PUBLICATIONS],
}

export function getUrlForSite(origin: string, site: SiteDto, language: Language): string {
  return [
    origin,
    language,
    ...SITE_TYPE_PATH[site.__typename],
    ...(!site.slug || site.slug === HOME_SLUG ? [] : [site.slug]),
  ]
    .join('/')
    .replace(/\/$/, '') // removes trailing slash if any
}

export interface AltUrl {
  lang: Language
  altUrl: string
  canonicalUrl: string
}

export interface AltUrls {
  [Language.DE]: AltUrl
  [Language.EN]: AltUrl
  [Language.FR]: AltUrl
}

export function createAltUrls(origin: string, route: ActivatedRouteSnapshot, site: SiteDto): AltUrls {
  const queryParams = Object.entries(route.queryParams)
    .map(([k, v]) => `${k}=${v}`)
    .join('&')

  const fragment = route.fragment ? `#${route.fragment}` : ''

  const altUrlsEntries = getEnumValues(Language).map((lang) => {
    const canonicalUrl = getUrlForSite(origin, site, lang)

    // todo check fragment & query params handling
    const altUrl = canonicalUrl + (queryParams ? `?${queryParams}` : '') + (fragment ? fragment : '')
    return [lang, { lang, altUrl, canonicalUrl } satisfies AltUrl] as const
  })

  return Object.fromEntries(altUrlsEntries) as any as AltUrls
}
